/* p3 [SOP-200]/[SOP-205] Block unwanted programmatic scrolls while preserving legit restore */
(() => {
  'use strict';

  // === GLOBAL Graphene veto helpers (new) ======================================
  // Hard-block late jumps from collection.min.js while veto is active.
  function __SOP_stackHasGraphene(){
    try { return /\/collection(\.min)?\.js/i.test((new Error()).stack||''); }
    catch(_) { return false; }
  }
  function __SOP_vetoActive(){ return (window.__SOP_VETO_GRAPHENE_UNTIL__||0) > Date.now(); }
  function __SOP_armVeto(ms=5000){ window.__SOP_VETO_GRAPHENE_UNTIL__ = Date.now() + ms; }

  // Quickview swatches must not change the collection's active color filter.
  // Actual facet navigation and Back retain their complete query string.
  (function preserveCollectionFilters(){
    function sanitize(url) {
      if (url == null || !(locked || preBlock)) return url;
      try {
        const next = new URL(url, location.href);
        if (next.pathname !== location.pathname || next.pathname.includes('/products/')) return url;
        const current = new URL(location.href).searchParams.get('color-print-name');
        if (current) next.searchParams.set('color-print-name', current);
        else next.searchParams.delete('color-print-name');
        return next.href;
      } catch (_) { return url; }
    }
    const push = history.pushState.bind(history);
    const replace = history.replaceState.bind(history);
    history.pushState = function(state, title, url) { return push(state, title, sanitize(url)); };
    history.replaceState = function(state, title, url) { return replace(state, title, sanitize(url)); };
  })();

  // Kill router’s saved positions so it won’t try to “help”
  try { sessionStorage.removeItem('react-router-scroll-positions'); } catch(_){}

  // Force manual restoration across the site (prevents browser auto scroll on back/forward)
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch(_){}

  // --- SOP: native push/replace helpers (bypass 3rd-party wrappers) ---
  (function setupSilentHistory(){
    const NativeProto = (window.History && window.History.prototype) || null;
    const _nativePush    = (NativeProto && NativeProto.pushState)    ? NativeProto.pushState    : history.pushState;
    const _nativeReplace = (NativeProto && NativeProto.replaceState) ? NativeProto.replaceState : history.replaceState;

    const nativePush    = _nativePush.bind(history);
    const nativeReplace = _nativeReplace.bind(history);

    function stampGuardAndAnchor(){
      try {
        window.__BLOCK_SCROLL_RESET_AT__ = Date.now();
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        window.__COOLDOWN_ANCHOR_Y__     = y;
        window.__SCROLL_COOLDOWN_UNTIL__ = Date.now() + 2500; // ~2.5s guard
      } catch(_) {}
    }

    // Expose helpers we can call from the app code
    window.__SOP_SILENT_PUSH__ = function(url){
      stampGuardAndAnchor();
      try { nativePush(history.state, "", url); } catch(_) { history.pushState(history.state, "", url); }
    };
    window.__SOP_SILENT_REPLACE__ = function(url){
      stampGuardAndAnchor();
      try { nativeReplace(history.state, "", url); } catch(_) { history.replaceState(history.state, "", url); }
    };
  })();

  /* =========================
     CONFIG
  ========================== */
  const QUICKVIEW_BTN    = '.C4JX9le7TLa_ljGVTdtg';
  const QUICKVIEW_MODAL  = '.quickview-modal';
  const QUICKVIEW_PORTAL = '.quickview-portal-container';
  const QUICKVIEW_CLOSE  = '.bSTYHKM5DmkHCCINpCgy';

  // block programmatic scrolls coming from the Graphene bundle
  const BLOCK_CALLER_PATTERNS = [/collection\.(min\.)?js/i];

  /* =========================
     GLOBALS
  ========================== */
  let locked = false;
  let preBlock = false;
  let savedY = 0;
  let scrollbarPadApplied = false;
  let mo = null;
  let safetyTimer = null;
  let prevScrollRestoration = null;

  // Allow-list flag for our single legit restore
  window.__ALLOW_COLLECTION_SCROLL__ = false;

  // Window to block programmatic resets after nav events
  window.__BLOCK_SCROLL_RESET_AT__ = 0;
  const BLOCK_RESET_MS = 3000;

  // Cooldown after allowed restore + anchor Y for guardian
  window.__SCROLL_COOLDOWN_UNTIL__ = 0;
  window.__COOLDOWN_ANCHOR_Y__ = 0;

  /* =========================
     HELPERS
  ========================== */
  function stickyActive() {
    return Date.now() < (window.__RESTORE_STICKY_UNTIL__ || 0);
  }

  function modalOpen() {
    return !!(document.querySelector(QUICKVIEW_MODAL) || document.querySelector(QUICKVIEW_PORTAL));
  }
  function callerIsBlocked() {
    try { return BLOCK_CALLER_PATTERNS.some(re => re.test((new Error()).stack || '')); }
    catch(_) { return false; }
  }
  function withinResetWindow() {
    const t = window.__BLOCK_SCROLL_RESET_AT__ || 0;
    return t && (Date.now() - t) < BLOCK_RESET_MS;
  }
  function inCooldown() {
    return Date.now() < (window.__SCROLL_COOLDOWN_UNTIL__ || 0);
  }
  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  /* =========================
     LOCK (quickview)
  ========================== */
  function lock() {
    if (locked) return;
    savedY = window.scrollY || document.documentElement.scrollTop || 0;
    try {
      prevScrollRestoration = history.scrollRestoration;
      history.scrollRestoration = 'manual';
    } catch (_){}
    const pad = getScrollbarWidth();
    if (pad > 0) {
      document.documentElement.style.setProperty('--sg-scrollbar-w', String(pad));
      document.body.style.paddingRight = `var(--sg-scrollbar-w)`;
      scrollbarPadApplied = true;
    }
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    locked = true;
  }
  function unlock(restore = true) {
    if (!locked && !preBlock) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    if (scrollbarPadApplied) {
      document.body.style.paddingRight = '';
      scrollbarPadApplied = false;
    }
    locked = false;
    preBlock = false;
    try {
      if (prevScrollRestoration) history.scrollRestoration = prevScrollRestoration;
      else history.scrollRestoration = 'auto';
    } catch (_){}
    if (restore) {
      _winScrollTo(0, savedY);
    }
  }
  function startObserver() {
    if (mo) return;
    mo = new MutationObserver(() => {
      const open = modalOpen();
      if (open && !locked) lock();
      if (!open && (locked || preBlock)) { stopObserver(); unlock(true); }
    });
    mo.observe(document.documentElement, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class','style','open','aria-hidden']
    });
  }
  function stopObserver() { if (mo) { mo.disconnect(); mo = null; } }

  /* =========================
     NAV RESET WINDOW + ANCHOR
  ========================== */
  (function patchHistory() {
    const _push = history.pushState, _replace = history.replaceState;

    function stampResetGuard() {
      try {
        window.__BLOCK_SCROLL_RESET_AT__ = Date.now();
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        window.__COOLDOWN_ANCHOR_Y__     = y;
        window.__SCROLL_COOLDOWN_UNTIL__ = Date.now() + 2500;
      } catch(_) {}
    }

    history.pushState = function(...args) { stampResetGuard(); return _push.apply(this, args); };
    history.replaceState = function(...args) { stampResetGuard(); return _replace.apply(this, args); };
    window.addEventListener('popstate', () => stampResetGuard(), true);
  })();

  /* =========================
     SCROLL / FOCUS GATES
  ========================== */
  const _winScrollTo = window.scrollTo.bind(window);
  const _winScrollBy = window.scrollBy.bind(window);
  const _winScroll   = (window.scroll || window.scrollTo).bind(window);

  // SOP-318: restore only after React commits the requested Graphene results.
  (function collectionPosition(){
    const storageKey = 'scrollbackPosition';
    function key(url, includePage) {
      const u = new URL(url, location.href);
      u.searchParams.delete('preview_theme_id');
      if (!includePage || u.searchParams.get('pg') === '1') u.searchParams.delete('pg');
      u.searchParams.sort();
      return u.pathname + '?' + u.searchParams.toString();
    }
    function readReturn() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        return saved.intent === 'pdp' && saved.url && saved.viewKey &&
          Date.now() - saved.savedAt < 30 * 60 * 1000 &&
          key(saved.url, true) === key(location.href, true) ? saved : null;
      } catch (_) { return null; }
    }
    let pending = readReturn();
    let previousKey = key(location.href, false);
    let stopSettling = function() {};
    function releaseGuards() {
      window.__SOP_FREEZE_UNTIL__ = 0;
      window.__RESTORE_STICKY_UNTIL__ = 0;
      window.__SCROLL_COOLDOWN_UNTIL__ = 0;
      window.__BLOCK_SCROLL_RESET_AT__ = 0;
    }
    function move(y) {
      y = Math.max(0, y);
      releaseGuards();
      window.__COOLDOWN_ANCHOR_Y__ = y;
      window.__SCROLL_COOLDOWN_UNTIL__ = Date.now() + 500;
      _winScrollTo({ top: y, behavior: 'instant' });
    }
    function settle(targetY) {
      stopSettling();
      let frame;
      const adjust = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => move(targetY()));
      };
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(adjust) : null;
      const root = document.getElementById('root');
      if (observer && root) observer.observe(root);
      const timer = setTimeout(() => stopSettling(), 1500);
      stopSettling = function() {
        cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        clearTimeout(timer);
        releaseGuards();
        stopSettling = function() {};
      };
      adjust();
    }
    function cancelForUser(event) {
      if (event.type === 'keydown' && !['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key)) return;
      stopSettling();
      releaseGuards();
      pending = null;
    }
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(type =>
      window.addEventListener(type, cancelForUser, { capture: true, passive: true }));

    document.addEventListener('click', function(event) {
      const link = event.target.closest && event.target.closest('a[href*="/products/"]');
      const card = link && link.closest('[data-plp-card-action][data-variant-key]');
      if (!card || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
          link.target === '_blank' || event.target.closest('.swiper-pagination, .swiper-button-next, .swiper-button-prev')) return;
      // Capture geometry before later click handlers can change the layout.
      const position = window.scrollY;
      const cardTop = card.getBoundingClientRect().top;
      // React/quickview can cancel the click. Only real navigation saves a return.
      queueMicrotask(function() {
        if (event.defaultPrevented) return;
        try {
          const url = new URL(location.href);
          const page = Number(card.getAttribute('data-plp-page')) || Number(url.searchParams.get('pg')) || 1;
          if (page > 1) url.searchParams.set('pg', String(page));
          else url.searchParams.delete('pg');
          if (url.href !== location.href) window.__SOP_SILENT_REPLACE__(url.href);
          const href = new URL(link.href, location.href);
          sessionStorage.setItem(storageKey, JSON.stringify({
            intent: 'pdp', savedAt: Date.now(), url: url.href,
            productId: card.getAttribute('data-product-id'),
            viewKey: card.getAttribute('data-variant-key'),
            color: href.searchParams.get('color-print-name') || '',
            href: link.getAttribute('href'), page,
            position, cardTop
          }));
        } catch (_) {}
      });
    }, true);

    window.__SOP_PLP_RENDERED__ = function() {
      const currentKey = key(location.href, false);
      if (pending && key(pending.url, true) === key(location.href, true)) {
        const saved = pending;
        const card = Array.from(document.querySelectorAll('[data-plp-card-action][data-variant-key]'))
          .find(el => el.getAttribute('data-variant-key') === saved.viewKey);
        // An intermediate render can precede the saved card. Retry on the next commit.
        if (!card) return;
        pending = null;
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
        settle(() => card && card.isConnected
          ? window.scrollY + card.getBoundingClientRect().top - saved.cardTop
          : saved.position || 0);
      } else if (currentKey !== previousKey) {
        pending = null;
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
        settle(() => {
          const root = document.getElementById('root');
          const header = document.querySelector('.shopify-section-header, header.header');
          return root ? window.scrollY + root.getBoundingClientRect().top - (header ? header.getBoundingClientRect().height : 0) - 16 : 0;
        });
      }
      previousKey = currentKey;
    };
    window.addEventListener('pageshow', function(event) {
      if (!event.persisted) return;
      pending = readReturn();
      window.__SOP_PLP_RENDERED__();
    });
  })();


  // --- desired variant key from session (pid::color) ---
  function getWantedVariantKey(){
    try {
      const sb = JSON.parse(sessionStorage.getItem('scrollbackPosition') || '{}') || {};
      const color = (sb.color || sb['color-print-name'] || '').toLowerCase();
      return (sb.productId && color) ? (String(sb.productId) + '::' + color) : '';
    } catch(_) { return ''; }
  }

  // --- climb up from an element to find the closest data-variant-key ---
  function nearestVariantKey(el){
    try {
      let n = el;
      while(n && n !== document.documentElement){
        if (n.getAttribute){
          const k = n.getAttribute('data-variant-key');
          if (k) return k;
        }
        n = n.parentNode;
      }
    } catch(_) {}
    return '';
  }

  // Gating predicate shared by wrappers
  function shouldBlockScroll() {
    if (window.__ALLOW_COLLECTION_SCROLL__) return false; // allow exactly one restore
    if (stickyActive()) return true;                      // block during sticky window
    if (inCooldown()) return true;
    if (withinResetWindow()) return true;
    if (callerIsBlocked()) return true;
    if (locked || preBlock) return true;
    return false;
  }

  // Allow one legit programmatic scroll (our restore), then create a sticky guard window
  function wrapScrollTo(original){
    return function(...args){
      // NEW: Graphene veto — kills calls from collection.min.js while veto is active
      if (__SOP_vetoActive() && __SOP_stackHasGraphene()){
        (window.sopTrace||console.debug)('[SOP-PLP] VETO window.scrollTo', {args});
        return;
      }

      if (window.__ALLOW_COLLECTION_SCROLL__) {
        try {
          let y = 0;
          if (args.length === 1 && args[0] && typeof args[0] === 'object') y = Number(args[0].top) || 0;
          else if (typeof args[0] === 'number' && typeof args[1] === 'number') y = Number(args[1]) || 0;
          const key = window.__RESTORE_TARGET_KEY__ || '';
          // Arm both freeze and the Graphene veto right after the legit restore
          (function armFreezeAndVeto(){ 
            try {
              const until = Date.now() + 5000;
              window.__SOP_FREEZE_UNTIL__       = until;
              window.__RESTORE_STICKY_Y__       = Math.max(0, Number(y) || 0);
              window.__RESTORE_STICKY_UNTIL__   = until;
              window.__COOLDOWN_ANCHOR_Y__      = Math.max(0, Number(y) || 0);
              window.__SCROLL_COOLDOWN_UNTIL__  = until;
              window.__RESTORE_TARGET_KEY__     = key || '';
            } catch(_){}
            __SOP_armVeto(5000);
          })();
        } catch(_){}
        try { window.__ALLOW_COLLECTION_SCROLL__ = false; } catch(_){}
        return original.apply(this, args);
      }

      // During freeze, swallow Graphene’s follow-up jump or any big move away from the anchor
      if (Date.now() < (window.__SOP_FREEZE_UNTIL__ || 0)) {
        const fromGraphene = /collection\.(min\.)?js/i.test((new Error()).stack||'');
        const yArg = (args && args[0] && typeof args[0]==='object') ? Number(args[0].top)||0
                  : (typeof args[1]==='number' ? Number(args[1])||0 : null);
        const stick = Number(window.__RESTORE_STICKY_Y__) || 0;
        const wouldMove = (yArg!=null) && Math.abs(yArg - stick) > 24;
        if (fromGraphene || wouldMove) {
          (window.sopTrace||function(){})('FREEZE block window.scrollTo', { args, fromGraphene, stickyY: window.__RESTORE_STICKY_Y__ });
          return;
        }
      }

      if (shouldBlockScroll()) return;
      return original.apply(this,args);
    };
  }

  function wrapWinGeneric(original, label){
    return function(...args){
      // NEW: Graphene veto for other win scrolling APIs
      if (__SOP_vetoActive() && __SOP_stackHasGraphene()){
        (window.sopTrace||console.debug)('[SOP-PLP] VETO window.'+label, {args});
        return;
      }
      if (shouldBlockScroll()) return;
      return original.apply(this,args);
    };
  }

  try { window.scrollTo = wrapScrollTo(_winScrollTo); } catch(_){}
  try { window.scrollBy = wrapWinGeneric(_winScrollBy,'scrollBy'); } catch(_){}
  try { window.scroll   = wrapWinGeneric(_winScroll,'scroll'); } catch(_){}

  const EP = Element.prototype;
  if (EP && EP.scrollTo) {
    const _elScrollTo = EP.scrollTo;
    EP.scrollTo = function(...args){
      if (__SOP_vetoActive() && __SOP_stackHasGraphene()){
        (window.sopTrace||console.debug)('[SOP-PLP] VETO el.scrollTo', {args});
        return;
      }
      if (shouldBlockScroll()) return;
      return _elScrollTo.apply(this,args);
    };
  }
  if (EP && EP.scrollBy) {
    const _elScrollBy = EP.scrollBy;
    EP.scrollBy = function(...args){
      if (__SOP_vetoActive() && __SOP_stackHasGraphene()){
        (window.sopTrace||console.debug)('[SOP-PLP] VETO el.scrollBy', {args});
        return;
      }
      if (shouldBlockScroll()) return;
      return _elScrollBy.apply(this,args);
    };
  }
  
  if (EP && EP.scrollIntoView) {
    const _elSIV = EP.scrollIntoView;
    EP.scrollIntoView = function(...args){
      // When a PLP card is being restored, anchor + veto to block the late jump
      try {
        const key = nearestVariantKey(this);
        const gridWrapSel = ['#main-collection-product-grid','.collection-grid','[data-graphene-collection]','.graphene-root','#MainContent'].join(',');
        if (key && this.closest && this.closest(gridWrapSel)) {
          const rect = this.getBoundingClientRect();
          const y = Math.max(0, (window.pageYOffset || 0) + rect.top - Math.round(window.innerHeight * 0.3));
          // freeze & veto for 5s
          try {
            const until = Date.now() + 5000;
            window.__SOP_FREEZE_UNTIL__       = until;
            window.__RESTORE_STICKY_Y__       = Math.max(0, Number(y) || 0);
            window.__RESTORE_STICKY_UNTIL__   = until;
            window.__COOLDOWN_ANCHOR_Y__      = Math.max(0, Number(y) || 0);
            window.__SCROLL_COOLDOWN_UNTIL__  = until;
            window.__RESTORE_TARGET_KEY__     = key || '';
          } catch(_){}
          __SOP_armVeto(5000);
        }
      } catch(_){}

      // If this call was the whitelisted one, clear the flag (old behavior remains compatible)
      if (window.__ALLOW_COLLECTION_SCROLL__) {
        try { window.__ALLOW_COLLECTION_SCROLL__ = false; } catch(_){}
        return _elSIV.apply(this, args);
      }

      // While sticky/cooldown is active, suppress scrolls that target a different card than the current “wanted”
      if (stickyActive() || inCooldown()) {
        try {
          const have = nearestVariantKey(this);
          const want = window.__RESTORE_TARGET_KEY__ || '';
          if (have && want && have !== want) return; // ignore scroll to wrong variant during window
        } catch(_){}
      }

      if (shouldBlockScroll()) return;
      return _elSIV.apply(this,args);
    };
  }

  if (EP && EP.focus) {
    const _elFocus = EP.focus;
    EP.focus = function(opts){
      if (locked || preBlock) {
        try { return _elFocus.call(this, { ...(opts||{}), preventScroll: true }); }
        catch(_) { return _elFocus.call(this); }
      }
      return _elFocus.call(this, opts);
    };
  }

  // === SOP: swallow wrong-variant scrollIntoView during cooldown (no new scrolls) ===
  (function sopSuppressWrongVariantOnly(){
    if (window.__SOP_SUPPRESS_WRONG_VARIANT__) return;
    window.__SOP_SUPPRESS_WRONG_VARIANT__ = true;

    function wantedKey(){
      try {
        const sb = JSON.parse(sessionStorage.getItem('scrollbackPosition') || '{}') || {};
        const c = (sb.color || sb['color-print-name'] || '').toLowerCase();
        return (sb.productId && c) ? (String(sb.productId) + '::' + c) : '';
      } catch(_) { return ''; }
    }
    function nearestKey(el){
      try {
        let n = el;
        while(n && n !== document.documentElement){
          if (n.getAttribute){
            const k = n.getAttribute('data-variant-key');
            if (k) return k;
          }
          n = n.parentNode;
        }
      } catch(_) {}
      return '';
    }
    function guardActive(){
      // reuse your existing timers
      return Date.now() < (window.__RESTORE_STICKY_UNTIL__ || 0) ||
            Date.now() < (window.__SCROLL_COOLDOWN_UNTIL__ || 0);
    }

    const EP = Element.prototype;
    if (!EP || !EP.scrollIntoView) return;

    const orig = EP.scrollIntoView;
    EP.scrollIntoView = function(...args){
      // NEW: ensure freeze+veto are armed when a PLP card is targeted
      try {
        const key = nearestKey(this);
        const insideCollection = (() => {
          try { return !!this.closest('#main-collection-product-grid, .collection-grid, [data-graphene-collection], .graphene-root, #MainContent'); }
          catch(_){ return false; }
        })();
        if (key && insideCollection){
          const rect = this.getBoundingClientRect();
          const y = Math.max(0, (window.pageYOffset||0) + rect.top - Math.round(window.innerHeight*0.3));
          const until = Date.now() + 5000;
          window.__SOP_FREEZE_UNTIL__       = until;
          window.__RESTORE_STICKY_Y__       = y;
          window.__RESTORE_STICKY_UNTIL__   = until;
          window.__COOLDOWN_ANCHOR_Y__      = y;
          window.__SCROLL_COOLDOWN_UNTIL__  = until;
          window.__RESTORE_TARGET_KEY__     = key;
          __SOP_armVeto(5000);
        }
      } catch(_){}

      try {
        const want = wantedKey();
        if (want && guardActive()){
          const have = nearestKey(this);
          if (have && have !== want){
            (window.sopTrace||function(){})('SIV suppressed wrong-variant', { want, have });
            return; // swallow the wrong jump; do NOT add any new scroll
          }
        }
      } catch(_) {}

      // fall back to your normal gates
      if (typeof shouldBlockScroll === 'function' && shouldBlockScroll()) return;
      return orig.apply(this, args);
    };
  })();


  /* =========================
    GUARDIAN: snap back during cooldown or sticky window (never fights the user)
  ========================== */
  (() => {
    let reentry = false, userUntil = 0;
    function markUser(){ userUntil = Date.now() + 1500; }
    function userActive(){ return Date.now() < userUntil; }
    window.addEventListener('wheel',       markUser, { capture:true, passive:true });
    window.addEventListener('touchmove',   markUser, { capture:true, passive:true });
    //window.addEventListener('pointerdown', markUser, { capture:true, passive:true });
    window.addEventListener('keydown',     markUser, { capture:true });

    function stickyActive() {
      return Date.now() < (window.__RESTORE_STICKY_UNTIL__ || 0);
    }
    function desiredY() {
      if (stickyActive()) return Math.max(0, Number(window.__RESTORE_STICKY_Y__) || 0);
      return Math.max(0, Number(window.__COOLDOWN_ANCHOR_Y__) || 0);
    }
    function guardActive() {
      if (stickyActive()) return true;
      return Date.now() < (window.__SCROLL_COOLDOWN_UNTIL__ || 0);
    }

    window.addEventListener('scroll', () => {
      if (!guardActive()) return;
      if (userActive()) return;
      if (window.__ALLOW_COLLECTION_SCROLL__) return;
      if (reentry) return;

      const y   = desiredY();
      const cur = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(cur - y) < 2) return;

      reentry = true;
      requestAnimationFrame(() => {
        const se = document.scrollingElement || document.documentElement;
        try { se.scrollTop = y; } catch(_) {}
        try { document.documentElement.scrollTop = y; } catch(_) {}
        try { document.body.scrollTop = y; } catch(_) {}
        reentry = false;
      });
    }, { capture:true, passive:true });
  })();


  /* =========================
     QUICKVIEW HOOKS
  ========================== */

  function armOpenSequence() {
    preBlock = true;
    lock();
    startObserver();
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(() => { if (!modalOpen()) { stopObserver(); unlock(true); } }, 1200);
  }
  function isAnchorJump(el) {
    if (!el || el.tagName !== 'A') return false;
    const href = el.getAttribute('href') || '';
    return href === '' || href === '#' || href.startsWith('#') || /^javascript:\s*void\(0\)\s*;?\s*$/i.test(href);
  }
  document.addEventListener('pointerdown', (e) => {
    const btn = e.target && e.target.closest && e.target.closest(QUICKVIEW_BTN);
    if (!btn) return; armOpenSequence();
  }, { capture:true });
  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest && e.target.closest(QUICKVIEW_BTN);
    if (!btn) return; if (isAnchorJump(btn)) e.preventDefault(); armOpenSequence();
  }, { capture:true });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const btn = e.target && e.target.closest && e.target.closest(QUICKVIEW_BTN);
    if (!btn) return; if (isAnchorJump(btn)) e.preventDefault(); armOpenSequence();
  }, { capture:true });
  document.addEventListener('click', (e) => {
    const closeBtn = e.target && e.target.closest && e.target.closest(QUICKVIEW_CLOSE);
    if (!closeBtn) return; stopObserver(); unlock(true);
  }, { capture:true });

  // === Prevent useless hash/empty anchor jumps inside the collection area ===
  (function preventCollectionAnchorJumps(){
    const COLLECTION_WRAPPERS = [
      '#main-collection-product-grid',
      '.collection-grid',
      '[data-graphene-collection]',
      '.graphene-root',
      '#MainContent'
    ];
    function insideCollection(el) {
      if (!el) return false;
      for (const sel of COLLECTION_WRAPPERS) {
        try { if (el.closest(sel)) return true; } catch(_) {}
      }
      return false;
    }
    function isUselessHash(href) {
      if (!href) return true;
      if (href === '#') return true;
      if (href.startsWith('#')) {
        const id = decodeURIComponent(href.slice(1));
        return !document.getElementById(id);
      }
      return false;
    }
    document.addEventListener('click', function(e){
      const a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (!insideCollection(a)) return;
      const href = a.getAttribute('href') || '';
      if (isUselessHash(href)) { e.preventDefault(); }
    }, { capture: true });
  })();

  // === SOP: Guard direct scrollTop writes during reset/cooldown (safe, no logging) ===
  (function guardScrollTopSets(){
    if (window.__SOP_SCROLLTOP_GUARD_INSTALLED__) return;
    window.__SOP_SCROLLTOP_GUARD_INSTALLED__ = true;

    function safeY() {
      return (typeof window.pageYOffset === 'number'
        ? window.pageYOffset
        : (typeof window.scrollY === 'number' ? window.scrollY : 0)) || 0;
    }
    function activeBlock() {
      // Let our one legit restore through
      if (window.__ALLOW_COLLECTION_SCROLL__) return false;

      // NEW: block direct writes from Graphene while veto is active
      try {
        if (__SOP_vetoActive() && __SOP_stackHasGraphene()) return true;
      } catch(_){}

      // NEW: also block during sticky window (right after we scroll to the correct card)
      if (typeof stickyActive === 'function' && stickyActive()) return true;
      if (Date.now() < (window.__SOP_FREEZE_UNTIL__ || 0)) return true;
      // Existing guards: cooldown/reset windows
      if (typeof inCooldown === 'function' && inCooldown()) return true;
      if (typeof withinResetWindow === 'function' && withinResetWindow()) return true;

      return false;
    }
    function install(target) {
      if (!target) return;
      try {
        const desc = Object.getOwnPropertyDescriptor(target, 'scrollTop');
        const get0 = desc && typeof desc.get === 'function' ? desc.get.bind(target) : null;
        const set0 = desc && typeof desc.set === 'function' ? desc.set.bind(target) : null;
        const configurable = !desc || desc.configurable;

        if (desc && configurable && (get0 || set0)) {
          Object.defineProperty(target, 'scrollTop', {
            configurable: true,
            get: function() { return get0 ? get0() : safeY(); },
            set: function(v) {
              if (activeBlock()) {
                try { (window.sopTrace||function(){})('SCROLLTOP suppressed', { v }); } catch(_){}
                return; // swallow during guard
              }
              if (set0) { try { set0(v); } catch (_) {} }
              else      { try { window.scrollTo(0, v); } catch (_) {} }
            }
          });
          return;
        }

        // Fallback: define a guarded property
        Object.defineProperty(target, 'scrollTop', {
          configurable: true,
          get: function() { return safeY(); },
          set: function(v) {
            if (activeBlock()) {
              try { (window.sopTrace||function(){})('SCROLLTOP suppressed', { v }); } catch(_){}
              return; // swallow during guard
            }
            if (set0) { try { set0(v); } catch (_) {} }
            else      { try { window.scrollTo(0, v); } catch (_) {} }
          }

        });
      } catch (_) { /* if we can't hook, guardian below still protects */ }
    }

    const se = document.scrollingElement || document.documentElement;
    install(se);
    install(document.documentElement);
    install(document.body);
  })();

  /* === SOP DEBUG: Programmatic scroll tracer (NO behavior changes) === */
  (function sopTrace(){
    const ENABLE = false; if (!ENABLE) return;

    function cutStack(s){
      try { return (s||'').split('\n').filter(l => !/sopTrace/.test(l)).slice(0,8).join('\n'); }
      catch(_) { return ''; }
    }
    function trace(label, extra){
      const st = cutStack((new Error()).stack);
      if (console.groupCollapsed) {
        console.groupCollapsed('[SOP-TRACE] ' + label, extra || '');
        if (extra) console.log(extra);
        if (st) console.log(st);
        console.groupEnd();
      } else {
        console.log('[SOP-TRACE] ' + label, extra || '', st);
      }
    }

    try {
      const o = window.scrollTo.bind(window);
      window.scrollTo = function(){ trace('window.scrollTo', { args: Array.from(arguments) }); return o.apply(this, arguments); };
    } catch(_){}
    try {
      const o = window.scrollBy.bind(window);
      window.scrollBy = function(){ trace('window.scrollBy', { args: Array.from(arguments) }); return o.apply(this, arguments); };
    } catch(_){}
    try {
      const base = (window.scroll || window.scrollTo).bind(window);
      window.scroll = function(){ trace('window.scroll', { args: Array.from(arguments) }); return base.apply(this, arguments); };
    } catch(_){}

    (function wrapEl(){
      const EP = Element.prototype; if (!EP) return;
      try { const f = EP.scrollIntoView; if (f) EP.scrollIntoView = function(){ trace('el.scrollIntoView', { el: this, args: Array.from(arguments) }); return f.apply(this, arguments); }; } catch(_){}
      try { const f = EP.scrollTo;       if (f) EP.scrollTo       = function(){ trace('el.scrollTo',       { el: this, args: Array.from(arguments) }); return f.apply(this, arguments); }; } catch(_){}
      try { const f = EP.scrollBy;       if (f) EP.scrollBy       = function(){ trace('el.scrollBy',       { el: this, args: Array.from(arguments) }); return f.apply(this, arguments); }; } catch(_){}
    })();

    (function wrapHistory(){
      try {
        const p = history.pushState, r = history.replaceState;
        history.pushState    = function(s,t,u){ trace('history.pushState', { url: String(u) }); return p.apply(this, arguments); };
        history.replaceState = function(s,t,u){ trace('history.replaceState', { url: String(u) }); return r.apply(this, arguments); };
      } catch(_){}
    })();

    document.addEventListener('click', function(e){
      const btn = e.target && e.target.closest && e.target.closest('button,a');
      trace('click', { target: e.target, button: btn, text: btn ? (btn.textContent || '').trim() : '' });
    }, { capture: true });
  })();

  // Prevent focus-induced scrolling during guards (sticky/cooldown/reset) and quickview lock
  (function patchFocus(){
    const EP = Element.prototype;
    if (!EP || !EP.focus) return;

    const _elFocus = EP.focus;
    EP.focus = function(opts){
      const guard =
        (typeof stickyActive === 'function' && stickyActive()) ||
        (typeof inCooldown === 'function' && inCooldown()) ||
        (typeof withinResetWindow === 'function' && withinResetWindow()) ||
        (typeof locked !== 'undefined' && locked) ||
        (typeof preBlock !== 'undefined' && preBlock);

      if (guard) {
        try { return _elFocus.call(this, { ...(opts||{}), preventScroll: true }); }
        catch(_) { return _elFocus.call(this); } // older browsers
      }
      return _elFocus.call(this, opts);
    };
  })();

})();
